import type { ReactNode } from 'react';

/**
 * Mention de l'offre du compte.
 *
 * Décision du propriétaire (08/10/2026) : afficher « Pro » pour tous tant que
 * les abonnements ne sont pas ouverts. C'est le SEUL endroit où ce libellé est
 * écrit : quand l'offre réelle de chaque entreprise existera, elle se lira ici
 * et nulle part ailleurs.
 */
export const CURRENT_PLAN_LABEL = 'Pro';

/** `subtle` : texte discret « · Pro » collé au nom (barre du compte), sans pastille. */
export function PlanBadge({ subtle = false }: { subtle?: boolean }): ReactNode {
  return (
    <span
      className={`plan-badge${subtle ? ' plan-badge--subtle' : ''}`}
      title={`Offre ${CURRENT_PLAN_LABEL}`}
    >
      <span className="sr-only">Offre </span>
      {CURRENT_PLAN_LABEL}
    </span>
  );
}
